import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { FloatingChat } from "@/components/FloatingChat";
import Home from "@/pages/Home";
import ApartmentPage from "@/pages/ApartmentPage";
import HotelPage from "@/pages/HotelPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <LangProvider>
        <BrowserRouter>
          <ScrollManager />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apartments/premium-inn" element={<HotelPage slug="premium-inn" />} />
            <Route path="/apartments/feniks" element={<HotelPage slug="feniks" />} />
            <Route path="/apartments/:slug" element={<ApartmentPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <FloatingChat />
          <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A1816", color: "#F9F6F0", border: "1px solid #36332E", borderRadius: "2px" } }} />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
